<template>
  <v-menu
    v-model="dateMenu"
    :close-on-content-click="false"
    :nudge-right="15"
    :nudge-top="30"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-bind="attrs"
        outlined
        hide-details="auto"
        readonly
        dense
        :label="label"
        :error="error"
        append-icon="mdi-calendar"
        background-color="#0000000f"
        v-on="on"
        :value="dateDisplay"
        :disabled="disabled"
        :rules="rules"
      ></v-text-field>
    </template>
    <v-date-picker
      :min="min"
      :value="date"
      @change="onDateChanged"
    ></v-date-picker>
  </v-menu>
</template>
<script>
export default {
  data: () => ({
    dateMenu: false
  }),

  props: {
    label: {
      default: '',
      type: String
    },

    error: {
      default: false,
      type: Boolean
    },

    rules: {
      type: Array
    },

    disabled: {
      default: false,
      type: Boolean
    },

    min: {
      default: '',
      type: String
    },

    date: {
      default: '',
      type: String
    }
  },

  computed: {
    dateDisplay() {
      return this.$options.filters.formatDatePicker(this.date)
    }
  },

  methods: {
    onDateChanged(value) {
      this.dateMenu = false
      this.$emit('dateChanged', value)
    }
  }
}
</script>
